import { TooltipContentProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { QesColors } from '@app/shared/qes-standards/colors';
import { ReactElement } from "react";

type PayloadItem = {
  dataKey: string;
  value: number;
  payload?: { name?: string; projectRunDate?: string };
};

const legendMap = [
  { color: QesColors.QesTertiaryRed2, key: 'red', label: 'Providers With Alerts' },
  { color: QesColors.QesTertiaryYellow2, key: 'yellow', label: 'Providers With Warnings Only' },
  { color: QesColors.QesTertiaryBlue1, key: 'blue', label: 'Providers With No Alerts or Warnings' }
];

const ProviderIntegrityTrendTooltip = ({ active, payload, label }: TooltipContentProps<ValueType, NameType>): ReactElement => {
  if (active && payload && payload.length) {
    const filtered = legendMap
      .map(l => {
        const p = payload.find((x) => x.dataKey === l.key);
        return p ? { ...l, value: p.value } : null;
      })
      .filter(Boolean);

    // Prevent tooltip if all values are zero
    const allZero = filtered.every(item => (item.value ?? 0) === 0);
    if (filtered.length === 0 || allZero) return null;

    // Try to get year from payload
    let title = label;
    const firstPayload = payload[0] as PayloadItem;
    if (firstPayload?.payload?.projectRunDate) {
      const date = new Date(firstPayload.payload.projectRunDate);
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      title = `${month} ${year}`;
    }

    return (
      <div className="ni-trend-tooltip">
        <div className="ni-trend-tooltip__title">{title}</div>
        <div className="ni-trend-tooltip__header">
          <div className="ni-trend-tooltip__header-type">Alert Type</div>
          <div className="ni-trend-tooltip__header-count">Alert Count</div>
        </div>

        {filtered.map((item) => (
          <div key={item.key} className="ni-trend-tooltip__row">
            <span className="ni-trend-tooltip__color" style={{ background: item.color }}></span>
            <span className="ni-trend-tooltip__label">{item.label}</span>
            <span className="ni-trend-tooltip__value">{item.value.toLocaleString()}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export { ProviderIntegrityTrendTooltip };